import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import moment from "moment";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import docRevsFunctions from "@/document/revisions/mixins/docRevsFunctions.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import stats from "@/data/forms/mixins/stats.js";
import relps from "@/data/forms/mixins/relps.js";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  mixins: [
    generateForms,
    generateID,
    docRevsFunctions,
    relationshipsFunctions,
    announcements,
    stats,
    relps,
    apptheme
  ],
  methods: {
    validate() {
      if (this.$refs.form.validate() === true) {
        this.enableBtnSpinSignup = true;

        // SET data source
        let tag = "U1";
        let dbs = "/user";
        // const did = "o";
        const did = this.generateDID("DATE", tag);
        const idg = this.generateIDG("date-gid");

        // GENERATE form
        let temp = this.generateUserForm(); // form is from compnew component

        // ASSIGN data
        temp.basic.email = this.email;
        temp.char.epri = this.email;
        temp.basic.did = did;
        temp.basic.idg = idg;
        temp.basic.tag = tag;
        temp.basic.dbs = dbs;

        // STATS
        temp.stats.dcrt = moment().format();
        // eslint-disable-next-line
        temp.stats.dexp = moment().add(6, 'months').format();
        // eslint-disable-next-line
        temp.stats.drev = moment().add(1, 'years').format();


        // REV
        temp.rev = this.generateInitialDocumentRev(tag);

        // RELPS
        // let relps = this.generateInitialRelationships(tag);
        // temp.relps = relps;

        // HELP
        // console.log("USER CREATED");
        // console.log(temp);

        // FIREBASE CREATE USER
        let email = this.email;
        let pass = this.password;
        // eslint-disable-next-line
        const t = this;
        // eslint-disable-next-line
        // console.log(email);
        // FIREBASE CREATE USER
        // eslint-disable-next-line
        firebase.auth().createUserWithEmailAndPassword(email, pass)
          // eslint-disable-next-line
          .then(firebaseUser => {
            var user = firebase.auth().currentUser;

            // FIREBASE CREATE USER
            // eslint-disable-next-line
            user.sendEmailVerification()
              .then(function() {
                // assign
                temp.basic.uid = firebaseUser.user.uid;
                // FIREBASE CREATE USER DOC
                // eslint-disable-next-line
                firebase.firestore().collection(dbs).doc(did).set(temp)
                  // eslint-disable-next-line
                  .then(function(doc) {
                    t.createFirebaseUserStats(temp);
                    t.createFirebaseUserRelps(did);
                    // stop spinner / show message
                    t.enableBtnSpinSignup = false;
                    // let m = doc.data();
                    let msg = "New user " + email + " was created.";
                    t.generateInfoSnackbar(t.ui.colorBlue1, msg);
                    // t.showSnackbar(m, "success");
                    t.$router.push("/signupvalid");
                    console.log(temp);
                  })
                  .catch(function(error) {
                    // stop spinner / show message
                    t.enableBtnSpinSignup = false;
                    t.showSnackbar(error.message, "error");
                  });
                // Email sent.
                // eslint-disable-next-line
              }).catch(function(error) {
                // stop spinner / show message
                t.enableBtnSpinSignup = false;
                t.showSnackbar(error.message, "warning");
              });
          })
          .catch(error => {
            // stop spinner
            t.enableBtnSpinSignup = false;
            // show message
            t.showSnackbar(error.message, "error");
          });
      }
    },
    createFirebaseUserStats(temp) {
      // database and address
      let tag = "G5";
      let db = this.defineDataSourceFromTag(tag);
      // let stats = this.formStatsUser;
      // stats.dcrt = moment().format();
      // // eslint-disable-next-line
      // stats.dexp = moment().add(3, 'months').format();
      // // eslint-disable-next-line
      // stats.drev = moment().add(1, 'years').format();

      // HELP
      console.log("CREATE FIREBASE USER STATS");
      console.log(db);
      // console.log(did);
      console.log(temp);

      // SAVE STATS
      // eslint-disable-next-line
      db.doc(temp.basic.did).set(temp.stats).then(() => {})
        // eslint-disable-next-line
        .catch((error) => {
          // eslint-disable-next-line
          this.generateInfoSnackbar("error", "new data upload failed");
        });
    },
    createFirebaseUserRelps(did) {
      // database and address
      let tag = "G6";
      let db = this.defineDataSourceFromTag(tag);
      let relps = this.formRelpsUser;

      // HELP
      console.log("CREATE FIREBASE DOCUMENT STATS");
      console.log(db);
      console.log(did);
      console.log(relps);

      // SAVE STATS
      // eslint-disable-next-line
      db.doc(did).set(relps).then(() => {})
        // eslint-disable-next-line
        .catch((error) => {
          // eslint-disable-next-line
          this.generateInfoSnackbar("error", "new data upload failed");
        });
    }
  }
};
